import {createStore} from "zustand/vanilla";
import {immer} from "zustand/middleware/immer";
import {useStore} from "zustand";

interface SkiAncillaryService {
  serviceType: string;
  participantId: string;
  isEditing: boolean
}

interface SkiAncillaryServiceState {
  skiServices: Record<string, SkiAncillaryService>,
  editingSkiServicesList: string[]
}

interface SkiAncillaryServiceStoreActions {
  startEditingService: (skiAncillaryState: SkiAncillaryService) => void;
  endEditingService: (skiServiceId: string) => void;
}

type SkiAncillaryServiceStore = SkiAncillaryServiceState & SkiAncillaryServiceStoreActions

export const createSkiAncillaryServiceStore = (initState: SkiAncillaryServiceState) =>
  createStore<SkiAncillaryServiceStore>()(
    immer((set) => ({
      ...initState,
      startEditingService(skiAncillaryState) {
        set(({skiServices, editingSkiServicesList}) => {
          const serviceId = `${skiAncillaryState.serviceType}-${skiAncillaryState.participantId}`
          skiServices[serviceId] = skiAncillaryState
          editingSkiServicesList.push(serviceId)
        })
      },
      endEditingService(skiServiceId) {
        set((state) => {
          state.editingSkiServicesList = state.editingSkiServicesList.filter(
            (id) => id !== skiServiceId
          )
        })
      },
    }))
  );

export const skiServiceIsBeingEdited = (skiServiceId: string) => ({ editingSkiServicesList }: SkiAncillaryServiceState) => {
  return editingSkiServicesList.includes(skiServiceId)
}

export const skiAncillaryServiceStore = createSkiAncillaryServiceStore({
  skiServices: {},
  editingSkiServicesList: []
})

type StoreSelector<T, S> = (state: S) => T
interface UseBoundStore<S> {
  (): S,
  <T>(selector: StoreSelector<T, S>): T
}

export const useSkiAncillaryServiceStore: UseBoundStore<SkiAncillaryServiceStore> = <T>(selector?: StoreSelector<T, SkiAncillaryServiceStore>) => {
  const store = useStore(skiAncillaryServiceStore);

  if(!selector) {
    return store;
  }

  return selector(store);
}
